<template>
  <div class="clear-float">
    <div v-if="type == 'horizontal'" class="horizontal">
      <div
        v-for="(option, index) in options"
        :key="`option-${index}`"
        class="legend-bar-holder">
        <div class="background-indicator" :style="{background:option.background}"></div>
        <div class="indicator-text">{{ option.text }}</div>
      </div>
    </div>
    <div v-if="type == 'vertical'" class="vertical">
      <ul>
        <li
          v-for="(option, index) in extendedOptions"
          :key="`item-option-${index}`"
          class="clear-float">
          <div class="background-indicator float-left" :style="{background:option.background}"></div>
          <div class="legend-info float-left">
            <span class="main-text-info">{{ option.mainText }}</span>
            <span class="sub-text-info">{{ option.subText }}</span>
          </div>
          <div class="legend-data float-right">
            <span class="main-text-info">{{ option.percentage }}</span>
            <span class="sub-text-info">{{ option.amount }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartLegend',
  props: {
    type: {
      type: String,
      default: 'horizontal',
    },
    options: {
      type: Array,
      default: () => {},
    },
    extendedOptions: {
      type: Array,
      default: () => {},
    },
  },
}
</script>
